import { t } from '@hefe/i18n';
import { BasketballEventsSlice } from '@hefe/store';
import { formatDate } from '@hefe/utils';
import { Button, Col, Row, Spin, Tabs } from 'antd';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store/store';
import UserEventsCalendarComponent from '../../components/user-events-calendar/user-events-calendar.component';
import UserEventsFilterComponent from '../../components/user-events-filter/user-events-filter.component';
import UserEventsComponent from '../../components/user-events/user-events.component';

export default function UserEventsPage() {
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);
  const [initialLoad, setInitialLoad] = useState(false);

  const pagination = useSelector(
    BasketballEventsSlice.basketballUserEventsPaginationSelector
  );

  const shouldGoBackDate = useSelector(
    BasketballEventsSlice.basketballUserEventsNextGoBackDateSelector
  );

  useEffect(() => {
    fetchEvents();
  }, []);

  const loadMoreButton = useMemo(() => {
    if (!pagination.has_past_events) {
      return;
    }

    const loadUntil = shouldGoBackDate.format('YYYY-MM-DD');

    return (
      <Button loading={loading} onClick={() => fetchEvents(true)}>
        {t('load_more.events', {
          date: formatDate(loadUntil),
        })}
      </Button>
    );
  }, [pagination, loading, shouldGoBackDate]);

  const fetchEvents = (goBack?: boolean) => {
    setLoading(true);
    dispatch(BasketballEventsSlice.fetchUserBasketballEvents(goBack))
      .unwrap()
      .finally(() => {
        setLoading(false);
        if (!goBack) {
          setInitialLoad(true);
        }
      });
  };

  if (!initialLoad && loading) {
    return <Spin size="large" />;
  }

  return (
    <Row>
      <Col xs={24}>
        <UserEventsFilterComponent />
      </Col>
      <Col xs={24}>{loadMoreButton}</Col>
      <Col xs={24}>
        <Tabs defaultActiveKey="1">
          <Tabs.TabPane tab={t('list')} key="1">
            <UserEventsComponent />
          </Tabs.TabPane>
          <Tabs.TabPane tab={t('calendar')} key="2">
            <UserEventsCalendarComponent />
          </Tabs.TabPane>
        </Tabs>
      </Col>
    </Row>
  );
}
